/**
 * COR DO ÍCONE ☰ (o botão que abre o menu lateral) — exceção por tenant.
 *
 * Regra geral do site: a cor sai de `cor13` (campo "Letra em fundo escuro" de
 * Personalizar site › Cores) — não existe campo próprio para o ícone. Isso funciona
 * em 2.181 dos 2.182 sites.
 *
 * O cs2409 (Lord Imóveis) é o ÚNICO com `cor13` PRETA: o topo dele é transparente
 * sobre foto e todo o resto do cabeçalho (logo, telefones, redes) é branco, então só
 * o ☰ saía preto, destoando em todas as páginas. Enquanto a configuração de cor do
 * tenant não for corrigida na origem ("Letra em fundo escuro" = #ffffff, que é o que
 * o campo quer dizer), o ícone dele fica branco por aqui.
 *
 * Para ligar em outro tenant, some o codsite em SITES_ICONE_MENU_BRANCO.
 */
export const SITES_ICONE_MENU_BRANCO = new Set<number>([2409]);

export function corIconeMenu(site: any, corPadrao: any): any {
    return SITES_ICONE_MENU_BRANCO.has(Number(site?.id)) ? '#ffffff' : corPadrao;
}
